// src/domains/auth/auth.usecases.ts

import {
  login,
  getToken,
  resetPassword,
  otpForgotPassword,
  changePassword,
  logout,
} from './auth.api';
import {
  ChangePasswordRequestBody,
  LoginRequestBody,
  OtpResponse,
  PasswordResetRequestBody,
  TokenRequestBody,
  TokenResponse,
} from './auth.types';
import { genericResponse } from '@/shared/types/api';

export const useLoginUseCase = () => {
  return async (payload: LoginRequestBody): Promise<OtpResponse> => {
    return login(payload);
  };
};

export const useValidateOtpUseCase = () => {
  return async (payload: TokenRequestBody): Promise<TokenResponse> => {
    return getToken(payload);
  };
};

export const useForgotPasswordUseCase = () => {
  return async (
    payload: PasswordResetRequestBody,
  ): Promise<genericResponse> => {
    return resetPassword(payload);
  };
};

export const otpForgotPasswordUseCase = () => {
  return async (): Promise<genericResponse> => {
    return otpForgotPassword();
  };
};

export const useChangePasswordUseCase = () => {
  return async (
    payload: ChangePasswordRequestBody,
  ): Promise<genericResponse> => {
    return changePassword(payload);
  };
};

export const useLogOutUseCase = () => {
  return async (): Promise<genericResponse> => {
    return logout();
  };
};
